import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  CustomInstructionsFormComponent,
  CustomInstructionValue,
} from '@components/forms/custom-instructions-form/custom-instructions-form.component';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
export interface CustomStyleSettingsData {
  customInstruction: CustomInstructionValue;
  meta: {
    canGenerate: boolean;
  };
}

export interface CustomStyleSettingsPayload {
  customInstruction: CustomInstructionValue;
}

@Component({
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ButtonModule,
    CustomInstructionsFormComponent,
  ],
  templateUrl: './custom-style-settings-dialog-content.component.html',
  styleUrl: './custom-style-settings-dialog-content.component.css',
})
export class CustomStyleSettingsComponent implements OnInit {
  canGenerate = false;

  customInstruction: CustomInstructionValue;

  constructor(
    private dialogRef: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig<CustomStyleSettingsData>,
  ) {}

  ngOnInit() {
    const { data } = this.dialogConfig;
    const { customInstruction, meta } = data;
    const { canGenerate } = meta;
    this.canGenerate = canGenerate;
    this.customInstruction = customInstruction;
  }

  onCustomInstructionChange(value: CustomInstructionValue): void {
    this.customInstruction = value;
  }

  handleCancelClick(): void {
    this.dialogRef.close();
  }

  handleSaveClick(): void {
    const payload: CustomStyleSettingsPayload = {
      customInstruction: this.customInstruction,
    };

    this.dialogRef.close(payload);
  }
}
